import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid justify-content-start align-items-start" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "col-2 text-2xl mt-3 mb-0" }, "COMPANIES:", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-7" }, null, -1)
const _hoisted_4 = { class: "col-3" }
const _hoisted_5 = { class: "px-3 my-4 font-bold" }
const _hoisted_6 = { class: "field grid" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "col-fixed",
  style: {"width":"100px"}
}, "Name", -1)
const _hoisted_8 = { class: "field grid" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "vat",
  class: "col-fixed",
  style: {"width":"100px"}
}, "Vat", -1)

import DialogLoader from "@/components/DialogLoader.vue";
import { onMounted, ref } from "vue";
import axios from "axios";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'TableCompanies',
  setup(__props) {

const companies = ref([]);
const addDialog = ref(false);
const company = ref({ name: "", vat: "" });
const showLoader = ref(false);

onMounted(() => {
  getCompanies();
});

function getCompanies() {
  showLoader.value = true;
  axios
    .get("apiadm/v1/companies")
    .then((response) => {
      companies.value = response.data;
    })
    .catch((err) => {
      store.dispatch("catchErr", err);
    })
    .finally(() => {
      showLoader.value = false;
    });
}

function saveCompanyDetails() {
  showLoader.value = true;
  axios
    .post("apiadm/v1/company", company.value)
    .then(() => {
      getCompanies();
      addDialog.value = false;
    })
    .catch((err) => {
      store.dispatch("catchErr", err);
    })
    .finally(() => {
      showLoader.value = false;
    });
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Button, {
          label: "Add Company",
          icon: "pi pi-plus",
          class: "p-button-success mt-2",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (addDialog.value = true))
        })
      ])
    ]),
    _createVNode(_component_DataTable, {
      value: companies.value,
      tableStyle: "min-width: 50rem"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "name",
          header: "Name"
        }),
        _createVNode(_component_Column, {
          field: "vat",
          header: "Vat"
        })
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_Dialog, {
      visible: addDialog.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((addDialog).value = $event)),
      header: "Add Company",
      modal: true,
      style: { width: '50vw' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_InputText, {
              id: "name",
              modelValue: company.value.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((company.value.name) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_InputText, {
              id: "vat",
              modelValue: company.value.vat,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((company.value.vat) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_Button, {
          label: "Save",
          icon: "pi pi-check",
          class: "p-button-success",
          onClick: saveCompanyDetails
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(DialogLoader, { showLoader: showLoader.value }, null, 8, ["showLoader"])
  ], 64))
}
}

})